import Table from '../table/Table'
import TableRowsHierarchical from '../table/TableRowsHierarchical'

const ViewTableRows = ({
  endpoint,
  result,
  visibleColumns,
  currentFilter,
  filterIndex,
  table,
  debouncedSearchTerm,
  lineActions,
  listActions,
  selection,
  handleAction,
  handleExpand,
  selectAction,
}) => {
  const { clickLine } = table
  const useHierarchical = table?.subLines && !debouncedSearchTerm

  if (useHierarchical) {
    return (
      <TableRowsHierarchical
        endpoint={endpoint}
        result={result}
        columns={visibleColumns}
        slug={currentFilter?.slug || ''}
        tableKey={table.tableKey}
        path={table.path}
        lineActions={lineActions}
        onAction={handleAction}
        listActions={listActions}
        selectedItems={selection.selectedItems}
        onItemSelect={(itemId, opts) => selection.toggleItem(itemId, opts)}
        hierarchicalConfig={table.subLines}
        filter={filterIndex}
      />
    )
  }

  return (
    <Table.Rows
      endpoint={endpoint}
      result={result}
      columns={visibleColumns}
      slug={currentFilter?.slug || ''}
      tableKey={table.tableKey}
      path={table.path}
      pathTemplate={table.pathTemplate}
      lineActions={lineActions}
      onAction={handleAction}
      listActions={listActions}
      selectedItems={selection.selectedItems}
      onItemSelect={(itemId, opts) => selection.toggleItem(itemId, opts)}
      clickLine={clickLine}
      onExpand={clickLine === 'expand' ? handleExpand : undefined}
      selectable={!!selectAction}
      draggable={table.draggable}
      emphasizeLine={table.emphasizeLine}
    />
  )
}

export default ViewTableRows
